import React, { useMemo } from "react";

import DebouncedNumberInput from "../../component/input/DebouncedNumberInput";
import { InputAdornment } from "@material-ui/core";
import { get } from "lodash";
import { maxValue } from "ra-core";
import { useFormState } from "react-final-form";

const AmountInput = ({
  referenceField = null,
  maxPerc = null,
  validate,
  ...props
}) => {
  const formState = useFormState();
  const targetAmount = useMemo(
    () => get(formState.values, referenceField),
    [formState.values, referenceField]
  );
  const maxAmount = useMemo(
    () => (targetAmount * (maxPerc / 100)).toFixed(2),
    [targetAmount, maxPerc]
  );
  return (
    <DebouncedNumberInput
      {...props}
      validate={[
        referenceField !== null &&
          maxValue(maxAmount, "ra.validation.amount_max"),
        validate,
      ].filter((f) => f !== undefined)}
      InputProps={{
        startAdornment: <InputAdornment position="start">€</InputAdornment>,
      }}
    />
  );
};
export default AmountInput;
